export default "__VITE_ASSET__BGe1VhrZ__"